.floating-text {
  display: flex;
  position: absolute;
  z-index: 10;
  top: -10000px;
  left: -10000px;
  opacity: 0;
  box-shadow: 0 5px 10px var(--shadow);
  transition: opacity 0.5s;
}
